export default "__VITE_ASSET__BX27aEzF__"